import React from "react";
import Imgix from "react-imgix";

const OptimizedImageCarreDesktopBig = ({ src, alt }) => {
  return (
    <Imgix
      src={`https://frwebdesign.net/images-site-web${src}`}
      width={625} // modifié à 500 au lieu de 900 pour la page d'accueil
      height={625}
      className="lazyload"
      imgixParams={{
        auto: "format,compress", // auto WebP/AVIF + compression
        fit: "crop", // adapte le cadrage
      }}
      htmlAttributes={{
        alt: alt,
      }}
    />
  );
};

export default OptimizedImageCarreDesktopBig;
